module.exports = __webpack_public_path__ + "static/media/modal-close-btn.30e2df5a.svg";